/* Functions.js */
import config from "../config";
import { getReadableDate } from "../js/tools.js";
import { formConfig } from '@/js/formConfig.js';

import { customLog } from "../js/customlog.js";
// eslint-disable-next-line no-unused-vars
const log = (str, type) => { if ( config.isAdminNavAllowed ){ customLog(str, type); }}; 


export default {
	data() {
		return {			
			oauth: {
				token_type:'',
				access_token:'',
				expires_in:''
			},
			registrationMean : '',
			lead : {	},
			idLead : config.idlead,
			config: config,
			currentPage : "loading",
			ownerKeyFromUrl: '',
			participationKeyFromUrl: '',
			isMailFieldDisabled: false,
			isPhoneFieldDisabled: false,
			/* Markers, to know if everything is received from the API at first load */
			leadDataAreReceived: false,
			localizingDataAreReceived: false,
			localizingData: null,
			allowFormToBeDisplayed: false,
			unlockFreeRetailersIDs: [],
			couponsDetails : [],
			numberOfCouponsInThisAction: 0,

			theFullFieldsList : null,
			requiredFieldsList : null,
			requiredFieldsShortList : null,
			/* meta related info */
			metaDataAreReceived: false,
			theMetaFieldsList : null,
			metaOtherFreeFieldsIds : [],
			allPossibleMetaAnswersId: [],
			firstPageOfThisForm: formConfig.formPages[0],
			userCanChooseBetweenCoupons: formConfig.userCanChooseBetweenCoupons,
			choosenCouponsId: [],
			onlyValidCouponsList: [],
		}
	},
	computed: {
		actionStartDate : function(){
			return getReadableDate(this.actionFullDates.registration.start);
		},
		actionEndDate : function(){
			return getReadableDate(this.actionFullDates.registration.end);
		},

		onChromiumBrowser(){
			return !!window.chrome;
		},

		isUserOnPortableDevice(){
			this.log("isUserOnPortableDevice", 'function');
			this.log(`Detection mobile: ${this.isUserOnMobile()}, detection mobile or tablet: ${this.isUserOnMobileOrTablet()}`, 'low');
			return this.isUserOnMobileOrTablet() || this.isUserOnMobile();
		},

		getUrlParamsHTML(){
			let html = "<ul>";
			let urlParams = new URLSearchParams(window.location.search);
			let bothMissing = false;
			if (urlParams.has('key')){
				let unsafeKey = urlParams.get('key');
				let safeKey = encodeURIComponent(unsafeKey);
				html += `<li><b>Key:</b> ${safeKey}</li>`;
			}
			if (urlParams.has('participationKey')){
				let unsafePartKey = urlParams.get('participationKey');
				let safePartKey = encodeURIComponent(unsafePartKey);
				html += `<li><b>Participation Key:</b> ${safePartKey}</li>`;
			}
			if(!urlParams.has('key') && !urlParams.has('participationKey')){
				bothMissing = true;
				html += `<li>Awaited participation params both missing from url</li>`;
			}
			if(!bothMissing && (!urlParams.has('key') || !urlParams.has('participationKey'))){
				html += `<li>At least one of the participation params is missing from url</li>`;
			}

			html += "</ul>";
			return html;
		},
	},

	mixins: [],

	methods: {

		/* DEVICE RELATED METHODS */

		checkUserAgentIsMobile(a){
			let check = false;
			if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.slice(0,4))){
				check = true;
			}
			return check;
		},

		isUserOnMobile(){
			const userAgents = navigator.userAgent||navigator.vendor||window.opera;
			return this.checkUserAgentIsMobile(userAgents);
		},

		isUserOnMobileOrTablet(){
			// This is the "short" version of the code.
			// Works on "Version mobile". When tablet display "Version PC", it does not return TRUE anymore! => Someone still can print from mobile chromium…
			let check = false;
			(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
			
			// but Android tablet does not make the check true.
			// So as a backup, I check if the device have touch support 
			// It's not foolproof: laptop can have touch support…
			if(!check){ check = this.hasTouchSupport(); }
			return check;
		},

		/* ANDROID TABLET is not detected as "mobile" or "tablet". Additionnal test could help. */
		hasTouchSupport() {
			return 'ontouchstart' in window || navigator.maxTouchPoints > 0; 
		},

		/* END OF DEVICE RELATED METHODS */




		/* DISPLAY AVAILABLE PARTICIPATION AND REGISTRATION */
		/* For console.INFO only */
		displayAvailableParticipations(){
			this.log(`Available registrations and participations`, "sep");
			this.log(`There are ${this.lead.inscriptions_left} available registrations`);
			this.log(`There are currently ${this.lead.inscriptions_total} registration(s) made`);
			this.log(`There are currently ${this.lead.participations_total} participation(s) received`);
			this.log(`There are still ${this.lead.participations_left} available participations`);
		},

		/* CHECK IF MAINTENANCE IS ON */
		/* AxiosBuilder takes care of this.$store.getters.getMaintenance if VUE_APP_ALLOWMAINTENANCECHECK is true in environment file */
		/* But maintenance can be forced by environment var in case of emergency */
		checkMaintenance() {
			if (config.forceMaintenanceInCaseOfProblem){
				console.log("Maintenance in progress…");
				this.currentPage = 'maintenance';
				this.allowFormToBeDisplayed = true; // Required, as the API-Calls never happend
			}else{
				/* If not forced, see if I received a status info from servers */
				let status = this.$store.getters.getMaintenance; 
				/* status:false = no maintenance */

				if (!status) {
					this.log("No maintenance in progress", "info"); 
					this.startAction();
				} 
				if(status) {
					this.log("Maintenance in progress", "alert"); 
					this.currentPage = 'maintenance';
					this.allowFormToBeDisplayed = true; // Required, as the API-Calls never happend
					this.log(`=> Redirection to the ${this.currentPage} page`, "low");
				}
			}
		},
		

		/* START OF THE ACTION */
		startAction() {
			this.getFromAxios(this.callConfigs.getLocalizedData);
			this.getFromAxios(this.callConfigs.getCountries);
			this.getFromAxios(this.callConfigs.getLead);
			this.getFromAxios(this.callConfigs.getSynonyms);
			this.getParticipationTypeReference();

			// We load coupons info only if this action MAY have coupons.
			if( formConfig.itsAnActionCoupon || formConfig.aCouponCouldBeSent ){
				this.log("Action is configured to be able to send coupon, we request coupon info then", 'info');
				this.getFromAxios(this.callConfigs.getCouponsDetails);
			}
			
		},


		/* ALLOW USER IF HE HAS NOT PARTICIPATED */
		checkIfAlreadyParticipated () {
			if (this.ownerData.status !== "30"){
				this.noParticipationYet();
			}else{
				this.participationAlreadySent();
			}
		},
		noParticipationYet(){
			this.log("Participation has not been sent yet.", 'low');
			this.checkParticipationDates();
		},
		participationAlreadySent(){
			this.log("Participation already sent and this is not a reparticipation.", 'low');
			this.goto('participated');
		},

		/* USER HAS ALREADY SOME DATA THAT COULD GO INTO FIELDS AT LOADING */
		putDataInFields(){
			this.log("(Re)participation -> putting data into fields", 'group');
			if(this.reparticipation){
				this.log ("This is a reparticipation", 'info');
				this.putDataIntoFieldsForAReparticipation();
			} else {
				this.log("This is no reparticipation", 'info');
				/* INFO I could get these data from the key, when I connect from the participationLink */
				this.IfMailPutMailInMailFieldAndDisable();
				this.ifPhonePutPhoneInPhoneFieldAndDisable();
				// Fill other form
				// this.fillFieldsWithOwnerData(['firstname', 'lastname']);
			}
			this.log('', 'groupEnd');
		},

		fillFieldsWithOwnerData(fields){
			/* fieldsValues keys and ownerData keys must have the same name, obvioulsy */
			fields.forEach(field =>{
				this.fieldsValues[field] = this.ownerData[field];
			});
		},

		/* IF MAIL DATA IS PRESENT, PUT IT IN THE FORM */
		IfMailPutMailInMailFieldAndDisable(){
			this.log(`Filling mail field with: ${this.ownerData.email} and locking it.`, 'low');
			if(this.ownerData.email){
				this.fieldsValues.email = this.ownerData.email;
				this.isMailFieldDisabled = true;
			}
		},

		/* IF PHONE DATA IS PRESENT, PUT IT IN THE FORM */
		ifPhonePutPhoneInPhoneFieldAndDisable(){
			this.log(`Filling phone field with: ${this.ownerData.phonenumber1} and locking it.`, 'low');
			if(this.ownerData.phonenumber1){
				this.setPhone(this.ownerData.phonenumber1);
				this.isPhoneFieldDisabled = true;
			}
		},

		justBeforeLoadingTheFormPage(){
			/* Here, one can perform a last-operation before going to the form page */
			this.goto(this.firstPageOfThisForm);
		},

		/* GET OWNER DATA FROM KEY */
		checkKey(){
			if(this.participationKeyFromUrl){
				this.getFromAxios(this.callConfigs.getParticipationOwnerData, this.participationKeyFromUrl);
			}else if(this.ownerKeyFromUrl){	
				this.getFromAxios(this.callConfigs.getOwnerData, this.ownerKeyFromUrl);
			}else{
				this.noOwnerDataToGet();
			}
		},

		/* MAX REGISTRATION/PARTICIPATION LEFT */
		isMaxRegistrationReached(){
			return this.lead.inscriptions_left <= 0;
		},
		isMaxParticipationReached(){
			return this.lead.participations_left <= 0;
		},

		/* REGISTRATION REQUIRED => CHECK REGISTRATION AVAILABILITY */
		whatToDoWhenRegistrationIsRequired(){
			if(this.isMaxRegistrationReached()){
				this.log("Max registration is reached: no new registration possible", 'info');
				this.goto('maxReached');
			}else{
				this.checkRegistrationDates();
			}
		},

		/* REGISTRATION NOT REQUIRED => CHECK PARTICIPATION AVAILABILITY */
		whatToDoWhenRegistrationIsNotRequired(){
			if(this.isMaxParticipationReached()){
				this.log("Max participation is reached: no new participation possible", 'info');
				this.goto('maxReached');
			}else{
				this.checkParticipationDates();
			}
		},






		checkActionStatusForAcceptance(tos){
			if(tos === "W"){ this.log(`The status need to be at least "O" for the action to be available for construction in acceptance.`, "alert"); }
			if(tos === "O"){ this.log(`The action is ready to be constructed in acceptance.`, "green"); }
			if(tos === "X"){ this.log(`The construction is possible.`, "green"); }
			if(tos === "T"){ this.log(`The action is tested by the client.`, "green"); }
			if(tos === "P"){ this.log(`The action is "live" in acceptance.`, "green"); }
			if (tos === 'C' || tos === 'A' || tos === 'R'){ this.log(`The action has been closed (C), cancelled (A) or refused (R) in acceptance.`, "red"); }
			this.log("-".repeat(60));
			/* In acceptance, we don't take status into account to continue to load the form… */
			this.continueWithTheChekIfAccessPossible();
		},

		checkActionStatusForProduction(tos){
			if(tos === "P"){
				this.log("Offer has 'P' status, action will be/is available for users.");
				this.log("-".repeat(60));
				this.continueWithTheChekIfAccessPossible();
			}
			if (tos === 'C' || tos === 'A' || tos === 'R'){
				/* The action is closed (C), canceled (A) or refused (R) */
				this.log("This action is closed.");
				this.goto("actionEnded");
			}
			if(tos === 'W' || tos === 'O' || tos === 'X' || tos === 'T'){
				/* Action should begin (dates are ok), but status is not right yet */
				this.log("This action is not yet in production, it is still waiting to receive the 'P' status.");
				this.goto("beforeStart");
			}	
		},

		/* CHECK IF USER CAN ACCESS THE FORM FOLLOWING CURRENT DATE AND ACTION STATUS */
		checkIfAccessToFormIsPossible() {
			let tos = this.lead.offerstatus.toUpperCase();
			/* INFO: status PRE : W, O, X, T */
			/* INFO: status POST : C, A, R */
			this.log("-".repeat(60));
			
			/* ONLY IN PRODUCTION BUILD */
			if (config.takeOfferStatusIntoAccount){
				this.checkActionStatusForProduction(tos);
			}

			/* FOR LOCALHOST OR ACCEPTANCE BUILDS */
			if (!config.takeOfferStatusIntoAccount){
				this.log(`The action status in L.M. ACCEPTANCE is set to ${tos}.`, "info");
				this.checkActionStatusForAcceptance(tos);
			}
		},

		getUniqueCoupon(){
			// If it's a "true" coupon action (participation/ecoupon route)
			if(formConfig.itsAnActionCoupon){
				return { id: this.onlyValidCouponsList[0].id, quantity: 1 };
			}
			// If it's a normal action that can send coupon, sometimes (participation/ route)
			if(!formConfig.itsAnActionCoupon){
				return { idLeadCoupon: this.onlyValidCouponsList[0].id, quantity: 1 };
			}
		},

		getRequestedCouponsList(){
			this.log("getRequestedCouponsList", 'function');
			let listOfCoupons = [];
			/* There is ONE or MORE coupons (if none, getRequestedCouponsList() is not reached) */

			/* There is exacly ONE coupon */
			if(this.numberOfCouponsInThisAction === 1){
				this.log("1 valid coupon detected in the lead", 'low');

				// There is no survey OR there is a survey and it was not skipped => add the details of ONE unique coupon
				if (!this.thereIsASurveyInThisAction || (this.thereIsASurveyInThisAction && !this.skipButtonIsClicked)){
					listOfCoupons.push(this.getUniqueCoupon());
				}
				// There is a survey but it was skipped => no coupon details to add
			}

			// There is MORE than one coupon !
			if(this.numberOfCouponsInThisAction > 1){
				this.log("There is more than 1 valid coupon in the lead", 'info');
				this.log(this.userCanChooseBetweenCoupons?"User can choose":"User has no choice", 'low');				

				if(!this.userCanChooseBetweenCoupons){

					if(!this.sendAllCoupons){
						this.log("Get first coupon to expire", 'low');
						listOfCoupons.push(this.getFirstCouponToExpire());
					}

					if(this.sendAllCoupons){
						this.log("Send all coupons", 'low');
						this.couponsDetails.forEach(coupon => {
							listOfCoupons.push({id: coupon.id, quantity: 1});
						});
					}
				}
				if(this.userCanChooseBetweenCoupons){
					// INFO if user can choose but don't, I send the first expiring coupon.
					// - So we don't really need a flag, it suffice to not propose a choice.
					// - But, as we can automate one display or another with the same var…
					// - It can be easier if we don't have to re-code the UI each time.
					this.log("Get user's choosen coupon", 'low');
					listOfCoupons = this.getUserCouponOfChoice();
				}

			}
			return listOfCoupons;
		},

		getFirstCouponToExpire(){
			this.log("getFirstCouponToExpire()", 'function');
			// this.couponsDetails
			const firstToExpire = this.couponsDetails.reduce((earliest, current)=>{
				const earliestDate = new Date(earliest.onlineenddate);
				const currentDate = new Date(current.onlineenddate);
				return currentDate < earliestDate ? current : earliest;
				/* More robust return: */
				// return isNaN(currentDate) || (!isNaN(earliestDate) && currentDate >= earliestDate) ? earliest : current;
			});
			return { id: firstToExpire.id, quantity: 1 };
		},

		getUserCouponOfChoice(){
			this.log("getUserCouponOfChoice()", 'function');
			// @click on a card, set this.choosenCouponsId with the data of the selected coupon.
			// returns an array
			if(this.choosenCouponsId && this.choosenCouponsId.length >= 1){
				this.log("User choose one or more coupons", 'low');
				const list = [];
				this.choosenCouponsId.forEach(coupon => {
					list.push({id: coupon, quantity: 1});
				});
				this.log(list);
				return list;
			}else{
				this.log("User did not choose any coupon, so we send one anyway…", 'low');
				return [this.getFirstCouponToExpire()];
			}
		},

		setChoosenCouponWithId(arr){
			this.log("emit received");
			// Caller: Triggered by componant coupon-chooser, on form.vue page.
			// this return an array of 0, 1, 2 or more ids…
			this.choosenCouponsId = arr;
			this.log(this.choosenCouponsId);
		},

		isThereAvailableParticipationsRemaining(){
			return this.lead.participations_left > 0;
		},

		continueWithTheChekIfAccessPossible(){
			if (this.isUserThereTooSoon()){
				this.log('The action has not started yet. No entry.', 'info');
				this.goto('beforeStart');
			}
			else if (this.isUserThereTooLate()){

				if(this.isUserAbleToReparticipate()){
					this.log('The action is closed. But reparticipations are still open.', 'info');	
					this.identifyOwnerByKey();
				}else{
					this.log('The action is closed. No entry.', 'info');
					this.goto('actionEnded');
				}

			}
			else if (!this.isUserThereTooSoon() && !this.isUserThereTooLate()){
				this.log('The action is open. User can enter.', 'success');
				this.identifyOwnerByKey(); /* Registration required or not, this is still needed for reparticipation. */
			}
			else {
				/* ! No page here for this case yet */
			}
		},

		/* FROM THE LOCALE, DEDUCE THE CURRENT COUNTRY ID */
		/* This seems to never be called anywhere */
		getCountryIdFromLocale(){
			let idCountryCode = this.$i18n.locale.slice(-2);
			let codes = ['', 'BE', 'FR', 'NL', 'LU', 'DE'];
			this.log(`I return ${codes.indexOf(idCountryCode)} as index of idCountryCode in codes`, 'low');
			return codes.indexOf(idCountryCode);
		},

		/* NO KEY IN THE URL, CHECK IF IT IS STILL POSSIBLE TO PARTICIPATE (maxReached) */
		noOwnerDataToGet(){
			if (!this.isThereAvailableParticipationsRemaining()){
				this.log('Max participation reached', 'info');
				this.currentPage = 'maxReached';
			}else{
				this.checkAndRedirectIfRegistrationRequired();
			}
		},

		/* CHECK IF USER MUST REGISTER HIMSELF */
		checkAndRedirectIfRegistrationRequired(){
			this.log("checkAndRedirectIfRegistrationRequired", 'function');

			// If registration required in the lead…
			if(this.registrationRequired){
				this.log("By the lead, registration is required!", 'info');

				if(formConfig.userCanRegisterOnTheForm){
					this.log("User can registrate himself", 'low');
					// Standard way of doing thing: user can registrate himself
					this.log("As registration is required, checking availability", 'low');
					this.whatToDoWhenRegistrationIsRequired();
				}

				if(!formConfig.userCanRegisterOnTheForm){
					this.log("User cannot registrate himself on this form", 'low');
					this.log("(He must be pre-registered", 'low');
					// User registration process is not allowed on this form
					this.log("No key => Redirection", 'low');
					this.goto('landing');
				}

			}

			if(!this.registrationRequired){
				this.log("Registration is not required", 'info');
				this.whatToDoWhenRegistrationIsNotRequired();
			}
		},


		/* PUT THE PHONE IN THE FORM */
		setPhone(value) {
			this.log("I set the phone value to: " + value, 'low');
			this.fieldsValues.phone1 = value;
		},

		/* PUT THE EMAIL IN THE FORM */
		setMail(value) {
			this.log("I set the mail value to: " + value, 'low');
			this.fieldsValues.email = value;
		},







		goto(dest){
			this.log(`I received ${dest} as a target destination`, 'low');

			/* add robot for non-indexing technical pages */
			this.checkForNonIndexablesPagesForThis(dest);
			this.logCustomEvent(dest); // for pixel.js
			this.currentPage = dest;
			this.$store.dispatch('setCurrentPage', dest);
			this.instantBackToTop();
			
			/* ACCESSIBILITY : code to focus on text so that readers can read the text directly*/
			if (dest === "confirmation") {
				setTimeout(function() {
					const el = document.getElementsByClassName("simpletext")[0];
					if (el) el.focus();
				}, 1000);
			}
		},

		instantBackToTop(){
			let el = document.getElementById("top")
			el.scrollIntoView({ behavior: "instant", block: "end", inline: "nearest" });
		},

		/* FLOODLIGHT */
		insertFloodLightScripts(dest) {
			if (dest != 'confirmation'){
				this.createEventScriptForLandingPage();
				this.createGlobalScriptForLandingPage();
			}
			if (dest === 'confirmation'){
				this.createEventScriptForThanksPage();
				this.createGlobalScriptForThanksPage();
			}
		},

		/* USER IS READY FOR HIS CASHBACK */
		userWantToClaimHisCashback(){
			this.log("userWantToClaimHisCashback", "function");
			this.log("User is ready and click to ask his cashback", 'sep');
			/* Check to avoid cheat by removing the "disables" attribute on button */
			if(this.isThereARequiredFieldMissing()){
				this.log("Some fields are missing", 'alert');
				this.displayModaleMessages(this.$t('errors.fieldsMissingTitle'), [this.$t('errors.fieldsMissing')], this.$t('errors.fieldMissingValueCsq'), 'alert')
			}
			if(!this.isThereARequiredFieldMissing()){
				this.continueToProcessTheForm();
			}
		},

		/* IS THERE A SURVEY? */
		continueToProcessTheForm(){
			if(!this.thereIsASurveyInThisAction){
				this.log("As there is no survey, I skip this step", 'low');
				this.skipSurvey();
			}	
			if(this.thereIsASurveyInThisAction){
				this.log("As there IS a survey, I go to the page that offer the choice to answer or not", 'low');
				this.goto('choiceSurvey');
			}	
		},



		/* GET AND RETURNS SOME KEYS FOUND IN THE URL */
		getKeysFromUrl(){

			this.log('Looking in the URL for keys','low');
			let urlParams = new URLSearchParams(window.location.search);

			/* In case of reparticipation, there SHOULD be a participationKey */
			if (urlParams.has('participationKey')){
				this.participationKeyFromUrl = urlParams.get('participationKey');
				this.log(`-> Found a participationKey: ${this.participationKeyFromUrl}`,'low');
			}else{
				this.log("-> No participation key found", 'low');
			}
			/* In case of participation, there COULD be a key */
			if (urlParams.has('key')){
				this.ownerKeyFromUrl = urlParams.get('key');
				this.log(`-> Found an owner key: ${this.ownerKeyFromUrl}`,'low');
			}else{
				this.log("-> No owner key found", 'low');
			}
		},

		/* CLAIMBLOCK TELLS WHAT USER WANT FOR REGISTRATION */
		setRegistrationMean(mean){
			this.registrationMean = mean;
		},

		/* IF LOCALE CHANGE, WHATSAPP CODE MUST BE REFRESHED */
		updateWhatsappCodes(){
			this.log("Getting codes for Whatsapp", 'low');
			try {
				let curloc = this.$i18n.locale.slice(0,2).toLowerCase();
				this.currentCodes = this.lead.registrationkeycode[curloc].trim();
			}catch(e){
				this.log(e, "alert");
			}
		},

		/* GET KEY AND FIND USER */
		identifyOwnerByKey () {
			this.getKeysFromUrl();
			this.checkKey();
		},

		/* IF THERE IS A SURVEY, SKIP IT */
		skipSurvey(){
			this.log("I skip the survey", 'low');
			this.surveyMustBeFilled = false;
			this.skipButtonIsClicked = true;
			this.log("I read the checklist", 'low');
			this.checkListBeforeSending();
		},

		/* I GOT OWNERDATA, NOW I USE THEM */
		setOwnerData(data){
			if(data.reparticipation) {
				this.ownerData = data["ParticipationOwner"];
				this.bigOwnerData = data;
				this.log("I found this IS a reparticipation", 'low');
				this.reparticipation = true;
			} else {
				this.log("I found this is NOT a reparticipation", 'low');
				this.ownerData = data;
			}
		},

		/* OWNER DATA IN CONSOLE */
		displayOwnerDataInConsole(){
			this.log("ownersData : participation, reparticipation", 'group')
			this.log(this.ownerData);
			this.log(this.bigOwnerData);
			this.log('', 'groupEnd');
		},

		/* SETTING LANG */
		/* (triggered by the participationOwner data callback) */
		setLang (id) {
			/* Updates i18n and store */
			let langs = ['en', 'fr', 'nl'];
			this.log(`Change lang to: ${langs[id]}`, 'low');
			let targetLocale = 'nl_BE';
			if (id == '1'){
				targetLocale = 'fr_BE';
			}else{
				targetLocale = 'nl_BE';
			}
			this.$i18n.locale = targetLocale;
			this.log(`The i18n Locale is now: ${this.$i18n.locale}`,'low');
			this.$store.dispatch('setIdLanguageCode', {id:id}); // If for a reason user change his speaking language
			this.$store.dispatch('setLocale', {locale: targetLocale});
			this.log(`The STORE locale is now ${this.$store.getters.getLocale}`, 'low');
		},

		/* CHECK this.fieldsValues.popitems, AND RETURN THOSE THAT CONTAINS A VALUE */
		returnsOnlyNonEmptyPopitems(){
			let list = [];
			for (let item in this.fieldsValues.popitems){
				if (this.fieldsValues.popitems[item]){
					list.push({"idPOPItem": this.fieldsValues.popitems[item], "quantity": 1});
				}
			}
			return list;
		},

		/* BLOCK BUTTONS AND CHECK IF PARTICIPATION COULD BE SENT */
		sendParticipation(){
			this.deactiveAllButtons();
			if(this.areConditionsToSendTheParticipationMet()){
				this.conditionsForParticipationAreMet();
			}else{
				this.conditionsForParticipationAreNotMet();
			}
		},
		conditionsForParticipationAreMet(){
			this.log(`Conditions to send the participation are OK`, 'green');

			this.composeData();

			this.log("Before posting, what did I received from composeData() ?");
			this.log(this.composedDataForParticipation);
			this.log("Participation will be rewritten by AxiosClass. What is present here may not be in the payload sent.", 'alert');

			// It should already be in there, but anyway =>
			// Put idParticipationType in the store, so it can be sent by AxiosClass interceptor

			this.log("Storing idParticipationType", 'group');
			const idParticipationType = this.composedDataForParticipation.Participation.idParticipationType;
			this.log(`The idParticipationType in the form is ${idParticipationType}`, 'low');
			this.log("Dispatching to the store…", 'low');
			this.$store.dispatch('setIdParticipationType', idParticipationType);
			this.log(`It's stored value is currently: ${this.$store.getters.getIdParticipationType}`, 'low');
			this.log("", 'groupEnd');

			this.sendTheRightParticipationType(this.composedDataForParticipation);
		},

		sendTheRightParticipationType(payload){
			/* TODO add if there is a survey */
			/* TODO ajouter : s'il y a une enquête remplie, s'il y a un "idLeadCoupon" reçu via le lead. */
			if(formConfig.itsAnActionCoupon){
				this.postToAxios(this.callConfigs.postCouponParticipation, payload);
			}else{
				this.postToAxios(this.callConfigs.postParticipation, payload);
			}
		},

		conditionsForParticipationAreNotMet(){
			this.log(`Conditions to send the participation are not OK`, 'red');
			this.activeAllButtons();
			this.displayModaleMessages('Error', [this.$t('errors.fieldMissingValue')], this.$t('errors.fieldMissingValueCsq'), 'alert');
			this.isClaimCashbackButtonActive = true;
			this.goto('form1');
		},

		convertCountryCodeToId(code) {
			this.log("convertCountryCodeToId", "function");
			this.log(`Received country code: ${code}`, "low");
			let theCorrespondingCountryIdsAre = this.listOfAllowedCountries.filter(country => country.code === code);
			this.log("Filtered countries: ", "low");
			this.log(theCorrespondingCountryIdsAre);
			return theCorrespondingCountryIdsAre[0].id;
		},

		convertCountryIdToDescription(id){
			this.log("convertCountryIdToDescription", "function");
			this.log(`Received id ${id} to convert to country description`, "wip");
			let theCorrespondingCountryDescriptionsAre = this.listOfAllowedCountries.filter(country => country.id === id);
			this.log("Filtered countries: ", "low");
			this.log(theCorrespondingCountryDescriptionsAre);
			return theCorrespondingCountryDescriptionsAre[0].description;
		},

		convertCountryCodeToDescription(code){
			this.log("convertCountryCodeToLocaleDescription", "function");
			this.log("Received country code: " + code, "low");
			let theCorrespondingCountryDescriptionsAre = this.listOfAllowedCountries.filter(country => country.code === code);
			this.log("Filtered countries: ", "low");
			this.log(theCorrespondingCountryDescriptionsAre);
			return theCorrespondingCountryDescriptionsAre[0].description;

		},


		toggleTestPanelVisibility(){
			this.fullTestPanelHidden = !this.fullTestPanelHidden;
		},

		checkListBeforeSending() {
			this.log("checkListBeforeSending", 'function');
			this.log("I read the item on the checklist", 'low');

			this.pendingParticipationSent = true;
			this.$store.dispatch('setSpinner', true);

			this.log(`I'm running the process to send the participation: ${this.pendingParticipationSent}`, 'low');
			// For usual action form
			if( !this.registrationRequired ){
				this.log("Registration is not required", 'info');
				if(formConfig.itsAnActionCoupon){
					this.log("Action coupon => Don't create an owner");
					this.sendParticipation();
				}else{
					this.log("Standard action => Create owner then send participation");
					this.createParticipationOwner();
				}
			}
			// For Performance Pack
			if( this.registrationRequired ){
				this.log("As registration is required beforehand, participationOwner exist, and I have already loaded it's data", 'info');
				this.sendParticipation();
			}
		},

		/* WHEN REPARTICIPATION, METHODS TO PUT SPECIFIC DATA INTO FIELDS */
		treatParticipationMetaData(category){
			/* la première reçue, avec idleadtmdv === 1 correspond à l'enquête, obligatoire ou non */
			/* La seconde seulement est une data utilisateur */
			this.bigOwnerData[category].forEach((item, index) => {
				if(item.idLeadTMD !== 1){
					this.log(item);
					this.fieldsValues.survey[`answersSQ${index+1}`] = item.idLeadTMDV;
					this.fieldsValues.survey[`answersSQ${index+1}alt`] = item.answer;
					this.log(this.fieldsValues.survey);
				}
			});
		},

		checkIfMaxParticipationReached(){
			if( this.isMaxParticipationReached() ){
				this.goto('maxReached');
			}
			if ( !this.isMaxParticipationReached() ){
				this.checkIfAlreadyParticipated();
			}
		},

		treatProofOfPurchaseHeaderConsumer(category){
			this.log("treatProofOfPurchaseHeaderConsumer", 'group');
			this.log(this.bigOwnerData[category].idpopretailer);
			this.fieldsValues.retailer = this.bigOwnerData[category].idpopretailer;
			this.fieldsValues.freeRetailer = this.bigOwnerData[category].freeretailername;
			this.fieldsValues.purchaseDate = this.bigOwnerData[category].purchasedate;
			this.log(this.bigOwnerData[category].freeretailername);
			this.log(this.bigOwnerData[category].purchasedate);
			this.log('', 'groupEnd');
		},

		treatParticipationOwnerData(category){
			let keys = Object.keys(this.bigOwnerData[category]);
			this.log(keys, 'low');
			if(typeof this.bigOwnerData[category] === 'object'){
				keys.forEach((key) => {
					this.log(this.bigOwnerData[category][key]);
					this.fieldsValues[key] = this.bigOwnerData[category][key];
				});
				this.log(this.fieldsValues);
			}
		},



		/*
		GENERAL USE TOOLS
		
		*/

		consoleHdRef(){
			this.log(`HDRef: ${config.refhd}`, 'info');
		},

		consoleDateOfBuild(){
			let buildDate = document.documentElement.dataset.buildTimestampUtc;
			let trueDate = new Date(buildDate);
			let year = trueDate.getFullYear();
			let month = trueDate.getMonth()+1;
			let dt = trueDate.getDate();
			this.log(`Date of build: ${dt}/${month}/${year}`, 'info');
		},



		/*
		API CALLBACKS (and the function calling if available)
		
		*/

		/* ++++ API CALL: GET PARTICIPATION TYPE REFERENCE ++++ */
		cb_participationTypeRefFound(data){
			this.participRefs = data;
			this.log("Refs stored in participRefs", 'low');
		},
		/* ---- API CALL: GET PARTICIPATION TYPE REFERENCE ---- */
		cb_participationTypeRefNotFound(err){
			this.log(err);
		},
		/* ==== API CALL: GET PARTICIPATION TYPE REFERENCE ==== */
		getParticipationTypeReference(){
			this.getFromAxios(this.callConfigs.getParticipationTypeRef);
		},


		// At statup form I call the API "getSynonyms"
		whatIfIGetTheSynonymsList(data){
			this.log(`I got a Synonyms list, stored in "synonyms"`, 'low');
			this.synonyms = data;
		},
		whatIfICantGetTheSynonymsList(err){
			this.log("APICallbacks > whatIfICantGetTheSynonymsList", "error");
			this.log(err);
		},


		/* SUCCESS FOR "POST PARTICIPATION" API CALL */
		participationSuccessful(res){
			this.log("The sending of the participation is a success", 'success');
			this.log(res);

			this.pendingParticipationSent = false;
			this.$store.dispatch('setSpinner', false);
			
			this.goto('confirmation');
		},
		/* ERROR FOR "POST PARTICIPATION" API CALL */
		participationFailed(error){
			this.log("participationFailed(error)", "function");
			this.log("The sending of the participation is a failure", 'alert');

			this.iGotThisErrorFromActionApi(error, this.$t('errors.participationNotSent'));

			this.pendingParticipationSent = false;
			this.$store.dispatch('setSpinner', false);

			this.isClaimCashbackButtonActive = true;
			this.goto('form1');
		},



































/* WIP 👷🚧========== START WIP 979 ==========🚧👷 */

		getOnlyAvailableCoupons(couponsList){
			return couponsList.filter(coupon => {
				if(coupon.idleadcouponlimittype === 1){
					return coupon.offersStillAvailableCounter > 0;
				}else{
					return coupon;
				}
			});
		},

		removeInvalidCoupons(data){
			this.log("removeInvalidCoupons(data)", 'function');
			this.log("Adding only valid coupons to the list", 'group');
			// Keep only those with date in range
			let cleanedArray = [];
			data.forEach(coupon => {			
				if(this.isThisCouponInDateRange(coupon)){
					cleanedArray.push(coupon);
				}
			});
			this.log("List of valid coupons after removing the old ones:", 'info');
			this.log(cleanedArray);
			this.log("Still a step to do: remove non-availables coupons", 'info');
			// Remove coupons that are not available anymore (offersStillAvailableCounter = 0)
			const availableValidCoupons = this.getOnlyAvailableCoupons(cleanedArray);
			this.log("Result: ", 'low');
			this.log(availableValidCoupons);
			return availableValidCoupons;
		},


/* WIP 👷🚧========== END WIP 979 ==========🚧👷 */







		areTheySomeValidCouponsInThisAction(){
			this.log("Creating a list with only valid coupons", 'title');
			const data = this.couponsDetails;
			// data is the original list of coupons
			const cleanedData = this.removeInvalidCoupons(data); // remove following dates AND availability
			this.onlyValidCouponsList = cleanedData;
			this.numberOfCouponsInThisAction = cleanedData.length;
			this.log(`How many valid coupons found in this action : ${this.numberOfCouponsInThisAction}`, 'info');

			// If there is no coupon (or not anymore), alert dev
			if(this.numberOfCouponsInThisAction <= 0){
				this.log("Action is configured to be able to send coupon, but there is no available coupon anymore (for PRINT or for REQ)", 'red');
				this.goto('maxReached');
				this.firstPageOfThisForm = 'maxReached';
			}
		},





		formatCouponsData(data){
			// I could add tags "couponAvailableForParticipation: x" and "couponAvailableForPrint: y" here to simplify tests later ?
			const formFormat = [];
			data.forEach(apiCoupon => {
				this.log(`Treating API coupon with id: ${apiCoupon.id}.`);
				const formCoupon = {};
				// Same value
				formCoupon.currentcounter = apiCoupon.currentcounter;
				formCoupon.description = apiCoupon.description;
				formCoupon.gcn = apiCoupon.gcn;
				formCoupon.onlinebegindate = apiCoupon.onlinebegindate;
				formCoupon.onlineenddate = apiCoupon.onlineenddate;
				// Value with treatment
				formCoupon.id = parseInt(apiCoupon.id);
				formCoupon.idleadmanagement = parseInt(apiCoupon.idleadmanagement);
				formCoupon.maxcounter = parseInt(apiCoupon.maxcounter);
				formCoupon.offersStillAvailableCounter = parseInt(apiCoupon.offersStillAvailableCounter);
				formCoupon.idleadcouponlimittype = parseInt(apiCoupon.idleadcouponlimittype);
				formCoupon.value = apiCoupon.nobon.nvaleu;
				// Adding that one coupon to the collective
				formFormat.push(formCoupon);
			});
			return formFormat;
		},


		// Je viens de recevoir d'action-api le détails des coupons pour une action-coupon.
		storeCouponsDetailsForTheForm(data){
			this.log("storeCouponsDetailsForTheForm(data)", 'function');
			this.log(data);
			// Je les stocke sans me poser de question
			const formCoupon = this.formatCouponsData(data);
			// Storing the values in the form's function's data
			this.couponsDetails.length = 0; // emptying without loosing reactivity
			this.couponsDetails.push(...formCoupon); // filling again
			this.log(`formCoupons stored`);

			this.areTheySomeValidCouponsInThisAction();

			// Coupons are stored, we should check if user can access the form or not.
			this.areCouponsAvailableForUserAction(); // will redirect or let the user continue on the form
		},

		isThisCouponInDateRange(coupon){
			// this.log("isThisCouponInDateRange", 'function');
			const now = new Date();
			const couponStartDate = new Date(coupon.onlinebegindate);
			const couponEndDate = new Date(coupon.onlineenddate);
			// long version
			if(couponEndDate < now || couponStartDate > now){
				this.log(`Coupon ${coupon.id} (${coupon.value}€) is out of date range`, 'red');
				return false;
			}
			if(couponEndDate > now && couponStartDate < now){
				this.log(`Coupon ${coupon.id} (${coupon.value}€) is good to go`, 'green');
				return true;
			}
			// short version
			return (couponEndDate > now && couponStartDate < now);
		},

		isThereSomeCouponWithReqLimit(couponsList){
			this.log("isThereSomeCouponWithReqLimit receiving couponsList:");
			this.log(couponsList);
			const listIsArray = Array.isArray(couponsList);
			this.log(listIsArray);
			// const presenceOfReqCoupons = couponsList.some(coupon => Number(coupon.idleadcouponlimittype) === 1);

			const presenceOfReqCoupons = couponsList.some(coupon => {
				this.log("+++", 'wip');
				this.log(coupon);
				this.log( coupon.idleadcouponlimittype );
				return Number(coupon.idleadcouponlimittype) === 1; 
				// 1 = print, 2 = request
			});

			this.log(presenceOfReqCoupons);
			return listIsArray && presenceOfReqCoupons;
		},

		isThereStillAvailableCouponsWithPrintLimit(couponsList){
			this.log("isThereStillAvailableCouponsWithPrintLimit receiving couponsList:");
			this.log(couponsList);
			// return Array.isArray(couponsList) && couponsList.some(coupon => Number(coupon.idleadcouponlimittype) === 2 && coupon.offersStillAvailableCounter > 0);
			return Array.isArray(couponsList) && couponsList.some(coupon => Number(coupon.idleadcouponlimittype) === 2);
		},

		isThereSomeAvailableCouponsWithinDateRange(couponsList){
			// must be in date range, must have his counter > 0, no matters if REQ or PRINT
			this.log("At least ONE coupon should be available:", 'low');
			return couponsList.some(coupon => this.isThisCouponInDateRange(coupon) );
		},

		areCouponsAvailableForUserAction(){
			this.log("areCouponsAvailableForUserAction()", 'function');
			this.log("Is user here to request coupon(s) or to print coupon(s)?", 'low');

			// We'll need to know why the user is here
			const userIsHereToPrintCoupons = this.checkParams(['page', {'page':1}, {'ope': 'printCoupon'}, 'participationKey']);

			// User is here to print coupon(s)
			// If there is [REQ presence], peu importe la limite, ça passe dans TOUS les cas.
			// If there is no [REQ presence], ça bloque selon [PRINT limit].
			if(userIsHereToPrintCoupons){
				this.log("User is here to print coupon!", 'info');
				const cond1 = this.isThereSomeCouponWithReqLimit(this.couponsDetails);
				const cond2 = this.isThereStillAvailableCouponsWithPrintLimit(this.couponsDetails);
				this.log(`cond1: ${cond1}`);
				this.log(`cond2: ${cond2}`);
				if( cond1 || cond2 ){
					this.log("There are some REQ coupons or some available PRINT coupons => Continue", 'info');
					// No redirection, form continues…
				}else{
					this.log("There are no available PRINT coupons or any REQ coupons => Redirection", 'info');
					this.goto("noMoreCoupon");
				}
			}

			// User is here to request coupon(s)
				// must have coupon (REQ || PRINT) IN DATE RANGE qui n'ont pas atteint 0
			if(!userIsHereToPrintCoupons){
				this.log("User is not here to print coupons", 'info');
				if(this.isThereSomeAvailableCouponsWithinDateRange(this.couponsDetails)){
					this.log("There are some coupon (PRINT or REQ) in date range => Continue", 'info');
					// No redirection, form continues…
				}else{
					this.log("There is no available (PRINT or REQ) coupon in date range => Redirection", 'info');
					this.goto("noMoreCoupon");
				}
			}

		},



















		/* ++++ COUPONS DETAILS OBTAINED ++++ */
		whatIfCouponsDetailsAreObtained(data){
			this.log("Coupons details obtained", 'green');
			this.log(`Initial coupons count: ${data.length}`, 'info');
			if(data.length > 0){
				this.log("Storing coupons details in the form format", 'low');
				this.storeCouponsDetailsForTheForm(data);
			}else{
				this.log("No coupons detected in this action", 'low');
				if(formConfig.itsAnActionCoupon || this.aCouponCouldBeSent){
					this.log("Action is configured to be able to send coupon, but there is no coupon available", 'error');
					this.log("Misconfiguration (no coupon in the lead or erroneous form config)", 'red');
					// changing target page destination
					this.firstPageOfThisForm = 'noMoreCoupon';
				}			
			}
		},
		/* ---- COUPONS DETAILS NOT OBTAINED ---- */
		whatIfCouponsDetailsAreNotObtained(error){
			this.log(error, 'alert');
			this.log("Coupons details not obtained", 'error');
		},




		/* FORM MUST CREATE A PARTICIPATION OWNER */
		createParticipationOwner() {
			this.log("createParticipationOwner", 'function');
			let data = {
				"idLeadManagement": config.idlead,
				"email" : this.fieldsValues.email,
				"idLanguageCode": this.getIdOfLanguage(),
			};
			this.log(data);
			this.postToAxios(this.callConfigs.postParticipationOwner, data);
		},

		/* SUCCESS CALLBACK FOR "POST PARTICIPATION OWNER" API CALL */
		successInCreateParticipationOwner(res) {
			this.log(`I managed to create the participationOwner ${res.data.participationOwner.id}`,'success');
			this.ownerData.id = res.data.participationOwner.id;
			this.sendParticipation();
		},

		/* ERROR CALLBACK FOR "POST PARTICIPATION OWNER" API CALL */
		failedInCreateParticipationOwner(error) {
			this.log("ParticipationOwner was not created", 'alert');

			this.iGotThisErrorFromActionApi(error, this.$t('errors.partOwnerNotCreated'));

			this.pendingParticipationSent = false;
			this.$store.dispatch('setSpinner', false);
		},

		/* SUCCESS CALLBACK FOR "GET THE LEAD" API CALL */
		whatIfIGetTheLead(data){
			/* As I receive the data, I set a marker */
			this.leadDataAreReceived = true;
			/* …then I go my business as usual. */
			this.lead = data;

			/* TODO must check that the lead is a legit one */
			/* Else, redirect to pageError */

			this.log(`The HDREF is : ${this.lead.referencehd} | The ID is : ${this.lead.id}`, "info");

			/* Look if registration is required or not */
			this.talkingAboutRegistration();

			this.metaIds = this.getFromAxios(this.callConfigs.getAllFieldsInfo);
			this.actionFullDates = this.getFullDates();

			/* Get products list */
			this.getFromAxios(this.callConfigs.getProductsIds);

			/* Get retailer list (if needed) */
			/* TODO add a check if a retailer field is required */
			this.getFromAxios(this.callConfigs.getRetailers);

			if (this.registrationRequired){
				this.updateWhatsappCodes();
			}
			this.displayAvailableParticipations();
			this.displayDatesInConsole();
			this.checkIfAccessToFormIsPossible();
		},


		whatIfIGetTheFields(data){
			this.log("I got the field info from API", 'low');
			this.log(data, "table");
			// storing the data
			this.theFullFieldsList = data;
			// then treating metadata
			this.whatMustBeDoneForMeta(data);

			/* Check required meta presence */
			/* ! Todo must compose the list of all possible answers' id */
			let allAnswerMetaIds = [];
			this.checkIfRequiredMetaIdsArePresents(allAnswerMetaIds);

		},

		whatIfIDontGetTheFields(error){
			this.iGotThisErrorFromActionApi(error, this.$t('errors.noFieldConfigFound'));
		},

		filterMetaFields(fullList){
			/* extract a META field list */
			return fullList.filter(el => el.tablename === "ParticipationMetaData");
		},

		filterRequiredFields(fullList){
			/* extract a MANDATORY field list */
			return fullList.filter(el => el.mandatory);
		},

		compareMetaSequence(a,b){
			if (a.sequence < b.sequence){ return -1; }
			if (a.sequence > b.sequence){ return 1; }
			this.log("Two Meta have the same sequence nummer", 'alert');
			return 0;
		},

		sortArrayOfMetaBySequence(arr){
			return arr.sort(this.compareMetaSequence);
		},

		shortenRequiredFieldList(){
			let shortList = [];
			this.requiredFieldsList.forEach(el => {
				shortList.push(el.fieldname);
			});			
			return shortList;
		},

		/* ! should be moved : it gets the fields, not only the metas */
		whatMustBeDoneForMeta(data){
			/* Setting a marker */
			this.metaDataAreReceived = true;
			this.theMetaFieldsList = this.sortArrayOfMetaBySequence(this.filterMetaFields(data));
			this.requiredFieldsList = this.filterRequiredFields(data);
			this.requiredFieldsShortList = this.shortenRequiredFieldList();
			/* Displaying these list in the console */
			this.displayRequiredFieldsList();
			this.displayMetaFieldsList();
			/* this.displayFullFieldsList(); */


			/* ! MUST CLEAN BELOW, but it's currently used to create the meta */
			let tableIds = [];
			let metaList = this.theMetaFieldsList;
			for (let item in metaList){
				tableIds.push(metaList[item].idleadtmd);
			}
			this.metaIds = [...tableIds];

			this.log("META question's IDs :", 'info');
			this.log(this.metaIds.join(', '));

			this.log("in whatIfIGetTheFields — to be continued", "wip");

			/* Fill fieldsValues with null data for futur usage */
			/* Only if there is none data already */
			if(this.fieldsValues.survey.length <=0 ){
				this.fillFieldsValueSurvey(metaList.length);
			}

			/* Extract information about answers and freeanswers */
			this.isThereFreeAnswersInThisForm(data);
		},





		fillFieldsValueSurvey(num){
			for (let i=0; i< num; i++){
				this.fieldsValues.survey['answersSQ' + (i+1)] = null;		
				this.fieldsValues.survey['answersSQ' + (i+1) + 'alt'] = null;	
			}
		},

		displayListOfMetaDescription(list){
			list.forEach(el => {
				this.log(`[${el.leadmanagementmetadata.answertype.type}] ${' '.repeat(10 - el.leadmanagementmetadata.answertype.type.length)} Id: ${el.idleadtmd} — ${el.leadmanagementmetadata.description}`, 'puce');
			})
		},

		displayRequiredFieldsList(){
			this.log("Mandatory Fields", "sep");
			this.log(this.requiredFieldsShortList.join(', '));
			this.log(this.requiredFieldsList, "table");
		},

		displayMetaFieldsList(){
			this.log("Meta Fields", "title");
			this.log(this.theMetaFieldsList, "table");
			this.log("Meta questions","group");

			// this.displayListOfMetaDescription(this.theMetaFieldsList);

			/* If there are list, display the answers (and IDs) */
			this.theMetaFieldsList.forEach(meta => {
				this.log(`Meta ${meta.idleadtmd} - ${meta.leadmanagementmetadata.answertype.type}`,"sep");
				this.log(`Question: ${meta.leadmanagementmetadata.description}`);
				if (meta.leadmanagementmetadata.answertype.type === "LISTE"){
					meta.leadmanagementmetadata.leadmanagementmetadatavalue.forEach(val => {
						this.log(`Answer ${val.id}: "${val.description}"`);
						this.allPossibleMetaAnswersId.push(val.id);
					});
				}
			});
			this.log("","groupEnd");
		},


		checkIfRequiredMetaIdsArePresents(){
			const metaList = this.allPossibleMetaAnswersId;
			this.log("checkIfRequiredMetaIdsArePresents", 'function');
			const env = config.isWebsiteInProduction ? 'production' : 'acceptance';
			let alert = false;
			formConfig.thoseMetaIdsMustBePresent[env]?.forEach(id => {
				if(!metaList.includes(id)){
					this.log(`The lead meta list does not seems to contains required id ${id}`, 'red');
					alert= true;
				}
			});
			if(alert){
				this.log("Missing required meta Id(s) from the lead", 'error');
				if(env === 'production'){
					/* TODO when route exists: call route to send email to Studio */
				}
			}else{
				this.log("All required meta Ids present in the lead", 'green');
			}
		},


		displayFullFieldsList(){
			this.log("All Fields", "sep");
			this.log(this.theFullFieldsList, "table");
		},




		isThereFreeAnswersInThisForm(data){
			this.log("isThereFreeAnswersInThisForm", "function");
			/* This function show in the console if a freeanswer must be created for a specific meta-field */
			/* ! Currently not a dynamic solution. If the ID change in the LEAD, I'm informed of the new ID via the console, but the form won't work anymore until I fix it */
			/* ! How can I store (and update) the description of the free answer? */
			/* ! It won't work for linked field that are NOT "free anwsers" */
			let filteredData = data.filter( field => field.fieldname === 'answer' );
			for (let field of filteredData){
				for (let answer of field.leadmanagementmetadata.leadmanagementmetadatavalue){
					if (parseInt(answer.freeanswer) === 1){
						this.metaOtherFreeFieldsIds.push(answer.id);
						let verb = parseInt(answer.freeanswermandatory)===1?"MUST":"COULD";
						this.log(`There ${verb} be a freeanswer for value ${answer.id} given in the field ${answer.idleadtmd} (question: "${field.leadmanagementmetadata.description}") `, "info");
					}else{
						this.log("There are no meta freeanswers in this form");
					}
				}
			}
		},






		/* If "registration" is a key, what is it's value */
		talkingAboutRegistration(){
			if("registration" in this.lead){
				this.log('There is a "registration" key in the lead', 'low');
				this.registrationRequired = this.isRegistrationRequired(); 
			}else{
				/* For unknow reason, there is no registration in this lead */
				this.log('There was NO "registration" key in the lead', 'alert');
			}
		},

		/* CHECK IF REGISTRATION KEY IS 1 OR 0 */
		isRegistrationRequired(){		
			let regReq = this.lead.registration === "1";
			this.log(`For this action, a registration is ${regReq?'':'not '}required.`, 'info');
			return regReq;
		},

		/* ERROR CALLBACK FOR "GET THE LEAD" API CALL */
		whatIfIDontGetTheLead(error){
			this.goto('pageError');
			this.iGotThisErrorFromActionApi(error, this.$t('errors.leadNotFound'));
		},

		/* SUCCESS CALLBACK FOR "GET RETAILERS" API CALL */
		whatIfIGetTheRetailersList(data){
			/* ? WHAT IF THERE IS NO RETAILERS (empty list)? */
			/* => Array is empty, the condition in the field is never true, so no other field appears */
			/* ? But does THIS code produce an blocking error? */
			/* The request give me the list of retailer. I can then extract the freefield IDs */
			let listFreeFields = data.filter(item => {
				return item.freefield === "1" || item.freefield === 1;
			});
			listFreeFields.forEach(item => {
				this.unlockFreeRetailersIDs.push(item.id);
			});
			this.log(`I got the list of the "Other" retailers`, 'info');
			this.log(this.unlockFreeRetailersIDs);
		},

		/* ERROR CALLBACK FOR "GET RETAILERS" API CALL */
		whatIfIDontGetTheRetailersList(error){
			this.log(error, 'alert');
			this.iGotThisErrorFromActionApi(error, this.$t('errors.retailerListNotFound'));
		},

		/* SUCCESS CALLBACK FOR "GET PRODUCTS IDS" API CALL */
		whatIfIFoundProductsIds(data){
			this.popitemlist = [...data];
		},

		/* ERROR CALLBACK FOR "GET PRODUCTS IDS" API CALL */
		/* ? Is this the right redirection? */
		whatIfICantFindProductId(error){			
			this.goto('pageError'); 
			this.iGotThisErrorFromActionApi(error, this.$t('errors.productCodesNotFound'));
		},

		/* SUCCESS CALLBACK FOR "GET LOCALIZING DATA" API CALL */
		localizingDataFound(data){
			/* Storing the data for futur usage */
			this.localizingData = data;
			/* setting the marker to allow the display of the form */
			this.localizingDataAreReceived = true;
			/* What is interesting in this function */
			this.langswitchsThatMustBePresent = [];

			/* Display more things */
			this.log("Localizing data", 'group');
			this.log("What I'm expecting as lang buttons: ", 'info');
			for (let item in data){
				/* Summary in the form: [info] BE 1 | FR 1*/
				this.log(`${data[item].countrycodereference.code} ${data[item].countrycodereference.id} | ${(data[item].languagecodereference.code)?.toLowerCase()} ${data[item].languagecodereference.id}`);
				/* Put them in a list */
				this.langswitchsThatMustBePresent.push(`${(data[item].languagecodereference.code)?.toLowerCase()}_${data[item].countrycodereference.code}`);
			}	
			/* …store the list */
			this.$store.dispatch('setLangList', this.langswitchsThatMustBePresent);

			this.log(this.langswitchsThatMustBePresent);
			this.log('', 'groupEnd');
		},

		/* ERROR CALLBACK FOR "GET LOCALIZING DATA" API CALL */
		localizingDataNotFound(error){
			this.iGotThisErrorFromActionApi(error, this.$t('errors.localizationDataNotFound'));
			this.log(error, 'alert');
		},


		/* RETURNS THE ID BASED ON CURRENT LOCALE */
		getIdOfLanguage(){
			this.log("getIdOfLanguage", 'function');
			/* This is used to complete participationOwner language */
			/* Default language is NL */
			// ! (still hardcoded as I don't receive any default value)
			let defaultLangId = 2;
			// Check what is in use in the current display
			let currentLocale = this.$i18n.locale.slice(0,2).toUpperCase(); // Returns FR, NL…
			// Get the exact ID of this currentLocale
			let refData = this.localizingData.filter(line => line.languagecodereference.code === currentLocale);
			let finalId = defaultLangId;
			finalId = refData[0].languagecodereference.id; // Maybe there are many results, but language is the same, so I only need the 0th value.
			this.log(`The ID for the current locale "${currentLocale}" is ${finalId}`, 'low');
			return finalId;
		},


		whatIfIGetTheParticipationOwnerData(data){
			/* SUCCES ACTIONS IS THE SAME AS WITH SIMPLE OWNER DATA*/
			this.whatIfIGetTheOwnerData(data);
		},
		whatIfIDontGetTheParticipationOwnerData(error){
			/* THIS SHOULD DISPLAY ANOTHER ERROR MESSAGE */
			this.goto('wrongcode2');
			this.iGotThisErrorFromActionApi(error, this.$t('errors.codeWrongOrUnidentified'));
		},

		/* ? could it be put in tools.js ? */
		checkForDifferentTypes(urlParams, type) {
			// type can be String, or Object with one property and it's expected value
			// exemple : "participationKey" or "{'page' : 1}"
			if (typeof type === 'string') {
				return urlParams.has(type);
			} else if (typeof type === 'object') {
				return Object.entries(type).every(([key, value]) => {
					return urlParams.has(key) && urlParams.get(key) === value.toString();
				});
			}
			return false;
		},

		/* ? could it be put in tools.js ? */
		checkParams(params) {
			// params can be either a String, an Object or an array with as many Strings and Objects as needed
			// this.checkParams('page'); // check that a param "page" is in the url
			// this.checkParams({'page':0}); // check that url param "page" has a value of 0
			// this.checkParams(['code', {'page':0}]); // check both the presence of "code" and the value 0 of "page"
			let self= this;
			const urlParams = new URLSearchParams(window.location.search);
			return (Array.isArray(params)) ? params.every(item => self.checkForDifferentTypes(urlParams, item)) : self.checkForDifferentTypes(urlParams, params);
		},


		ownerIsLegitToParticipateHere(data){
			/* Owner is identified as a participant of this action */
			this.setOwnerData(data);
			this.displayOwnerDataInConsole();
			this.setLang(this.ownerData.idlanguagecode);
			// I must bypass the reparticipation checks if user is here for a coupon print
			if(this.checkParams(['page', {'page':1}, {'ope': 'printCoupon'}, 'participationKey'])){

				this.goto('printcoupon');

			}else if(this.checkParams(['page', {'page':0}, {'ope': 'printCoupon'}, 'participationKey'])){
				this.goto('choosecouponway');
			}else{
					// User is not here to print a coupon
				if ( this.reparticipation ){
					this.checkReparticipationDates();
				}else{
					this.checkIfMaxParticipationReached();
				}
			}
		},


		/* SUCCESS CALLBACK FOR "GET PARTICIPATION OWNER DATA" API CALL */
		whatIfIGetTheOwnerData(data){
			/* Check if the lead of the owner and the lead of this action are the same */
			/* So we cannot fill a form of another action! */

			let idFromUserData = data.idLeadManagement ? data.idLeadManagement : data.idleadmanagement;

			this.log(`id lead: ${idFromUserData}, id owner: ${this.lead.id}`, 'wip');
			/* ! They should be both Stringified for comparaison */
			if("" + idFromUserData === "" + this.lead.id){
				this.ownerIsLegitToParticipateHere(data);
			}else{
				this.log("IDs of owner and action are differents", "alert");
				this.whatIfIDontGetTheOwnerData();
			}
		},

		/* ERROR CALLBACK FOR "GET PARTICIPATION OWNER DATA" API CALL */
		whatIfIDontGetTheOwnerData(error){
			this.goto('wrongcode');
			this.iGotThisErrorFromActionApi(error, this.$t('errors.codeWrongOrUnidentified'));
		},


		/* ADD META FOR NON-INDEXABLE PAGES, FOR ROBOTS */
		/* INFO the goto() function trigger this. */
		checkForNonIndexablesPagesForThis(dest){
			let notIndexablePages = ['wrongcode', 'maintenance', 'confirmRegistration', 'confirmation', 'maxReached', 'demo', 'loading', 'pageError'];
			if (notIndexablePages.includes(dest)){
				this.addRobotsNoIndexMeta(); 
			}else{
				this.removeRobotsNoIndexMeta();
			}
		},
		/* REMOVE META "ROBOTS" */
		removeRobotsNoIndexMeta(){
			document.querySelector("[name='robots']")?.remove();
			this.log('Meta "Robot" is absent or removed', 'low');
		},
		/* ADD META "ROBOTS" */
		addRobotsNoIndexMeta(){
			const metaRobots = document.createElement('meta');
			metaRobots.name = 'robots';
			metaRobots.content = 'noindex';
			document.head.appendChild(metaRobots);
			this.log('meta "Robot" had been added to the page', 'low');
		},

		getDataGathered(){
			return this.leadDataAreReceived && this.localizingDataAreReceived && this.metaDataAreReceived;
		},

		maybeAllowTheForm(functionName='N/A'){
			this.log(`This data has changed: ${functionName}`, "low");
			if(this.getDataGathered()){
				this.log("All required data for the form are received", 'success');
				this.log("Allowing the form to be displayed", 'low');
				this.allowFormToBeDisplayed = true;
			}
		},

	},

	watch: {
		/* INFO: If one of these three data change, there is a check, and if all three values are true, allow access to form */
		leadDataAreReceived(){
			this.maybeAllowTheForm('leadDataAreReceived');
		}, 
		localizingDataAreReceived(){
			this.maybeAllowTheForm('localizingDataAreReceived');
		},
		metaDataAreReceived(){
			this.maybeAllowTheForm('metaDataAreReceived');
		},
	}

}

